<template>
  <subPageBanner pageTitle="txt_iletisim" />

  <div class="container-fuild mt-4 contact-page-area mb-5">
    <div class="container">
      <div class="row align-items-center" style="min-height: 550px">
        <div class="col-12 col-md-6 contact-page-left mb-5">
          <section>
            <strong class="d-block">{{
              this.$store.getters.getWordLocale("txt_yetkili_kisi")
            }}</strong>
            <span>{{ contactPerson }}</span>
          </section>

          <section class="mt-4">
            <strong class="d-block">{{
              this.$store.getters.getWordLocale("txt_adres")
            }}</strong>
            <span>{{ companyAddress }}</span>
          </section>

          <section class="mt-4">
            <strong class="d-block">{{
              this.$store.getters.getWordLocale("txt_telefon")
            }}</strong>
            <span>{{ phone }}</span>
          </section>
        </div>

        <div class="col-12 col-md-6">
          <div class="contact-page">
            <form class="contact-page-information-form">
              <div class="row">
                <div
                  v-show="this.$store.state.userLoggedInX == false"
                  class="col-lg col-12 mb-4"
                >
                  <input
                    type="text"
                    v-bind:class="{
                      'form-control': true,
                      'red-border': v$.form.nameSurname.$errors.length > 0,
                      'green-border':
                        userNameOut && v$.form.nameSurname.$errors.length == 0,
                    }"
                    v-on:focusout="validateNamesurname"
                    v-model="form.nameSurname"
                    :placeholder="
                      toTitles(
                        this.$store.getters.getWordLocale('txt_ad_soyad')
                      )
                    "
                  />
                  <div
                    class="form-error"
                    v-show="v$.form.nameSurname.$errors.length > 0"
                  >
                    {{
                      this.$store.getters.getWordLocale("txt_adinizi_giriniz")
                    }}
                  </div>
                </div>
                <div
                  v-show="this.$store.state.userLoggedInX == false"
                  class="col mb-4"
                >
                  <input
                    type="text"
                    v-on:focusout="validateEmail"
                    v-model="form.email"
                    v-bind:class="{
                      'form-control': true,
                      'red-border': v$.form.email.$errors.length > 0,
                      'green-border':
                        emailOut && v$.form.email.$errors.length == 0,
                    }"
                    :placeholder="
                      this.$store.getters.getWordLocale('txt_eposta')
                    "
                  />
                  <div
                    class="form-error"
                    v-show="v$.form.email.$errors.length > 0"
                  >
                    {{
                      this.$store.getters.getWordLocale(
                        "txt_gecerli_eposta_adresi_giriniz"
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-12 mb-4">
                  <input
                    v-model="form.companyName"
                    type="text"
                    v-bind:class="{
                      'form-control': true,
                    }"
                    :placeholder="
                      toTitles(
                        this.$store.getters.getWordLocale('txt_firma_adi')
                      )
                    "
                  />
                </div>
              </div>

              <div
                v-show="
                  this.$store.state.userLoggedInX == false &&
                  validCountryCode == false
                "
                class="mb-4"
              >
                <select
                  v-model="form.country"
                  v-bind:class="{
                    'form-select form-control': true,
                    'red-border': form.country == '' && submitted,
                    'green-border': form.country != 0,
                  }"
                  @change="setSelectedCountryId($event)"
                >
                  <option
                    v-for="(country, ci) in countries"
                    :key="ci"
                    :value="country.code"
                    v-bind:class="{
                      disabled: country.id == 0,
                      selected: country.id == 0,
                    }"
                  >
                    {{ country.text }}
                  </option>
                </select>
                <div class="form-error" v-show="form.country == 0 && submitted">
                  {{ this.$store.getters.getWordLocale("txt_lutfen_ulke_sec") }}
                </div>
              </div>
              <div class="mb-4">
                <input
                  v-on:focusout="validateSubject"
                  v-model="form.subject"
                  :placeholder="
                    toTitles(this.$store.getters.getWordLocale('txt_konu'))
                  "
                  type="text"
                  v-bind:class="{
                    'form-select form-control': true,
                    'red-border': v$.form.subject.$errors.length > 0,
                    'green-border':
                      subjectOut && v$.form.subject.$errors.length == 0,
                  }"
                  id=""
                  maxlength="250"
                  minlength="5"
                />
                <div
                  class="form-error"
                  v-show="v$.form.subject.$errors.length > 0"
                >
                  {{ this.$store.getters.getWordLocale("txt_konu_giriniz") }}
                </div>
                <div
                  v-bind:class="{
                    'float-end': true,
                    'mb-3': true,
                  }"
                >
                  {{ form.subject.length }}/250
                </div>
              </div>
              <div class="mb-4">
                <textarea
                  minlength="6"
                  maxlength="700"
                  v-on:focusout="validateMessage"
                  v-model="form.message"
                  v-bind:class="{
                    'form-select form-control': true,
                    'red-border': v$.form.message.$errors.length > 0,
                    'green-border':
                      messageOut && v$.form.message.$errors.length == 0,
                  }"
                  :placeholder="
                    toTitles(this.$store.getters.getWordLocale('txt_mesaj'))
                  "
                ></textarea>
                <div
                  class="form-error"
                  v-show="v$.form.message.$errors.length > 0"
                >
                  {{ this.$store.getters.getWordLocale("txt_mesaj_giriniz") }}
                </div>
                <div
                  v-bind:class="{
                    'float-end': true,
                    'mb-3': true,
                  }"
                >
                  {{ form.message.length }}/700
                </div>
              </div>
              <div class="d-flex justify-content-between mt-4 w-100">
                <div class="footer-file-box">
                  <!--

               
              <a class="btn"
                ><i class="material-icons-outlined">attach_file</i> Attach</a
              >
               -->
                </div>

                <a
                  href="javascript:;"
                  v-on:click="submitForm"
                  class="btn btn-online-primary"
                >
                  {{
                    toTitles(
                      this.$store.getters.getWordLocale("txt_mesaj_gonder")
                    )
                  }}

                  <span v-show="sendingMessage"
                    ><i class="fa fa-spinner fa-spin"></i
                  ></span>
                </a>
              </div>
            </form>

            <div
              class="alert mt-1 alert-success text-center"
              v-show="messageSent"
            >
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_mesajiniz_basariyla_gonderildi"
                )
              }}
            </div>

            <div
              class="alert mt-1 alert-danger text-center"
              v-show="errorSending"
            >
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_mesaj_gonderirken_hata_olustu"
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>

<script>
import useValidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";
import subPageBanner from "./components/SubPageBanner.vue";
import helper from "../theme5/helper";

export default {
  components: {
    subPageBanner,
  },
  data() {
    return {
      messageOut: false,
      subjectOut: false,
      emailOut: false,
      userNameOut: false,
      validCountryCode: false,
      companyName: "",
      errorSending: false,
      messageSent: false,
      sendingMessage: false,
      submitted: false,
      v$: useValidate(),
      form: {
        nameSurname: "",
        companyName: "",
        email: "",
        country: "",
        subject: "",
        message: "",
      },
      countries: [],
      companyAddress: "",
      contactPerson: "",
      phone: "",
    };
  },
  validations() {
    return {
      form: {
        nameSurname: { required },
        email: { required, email },
        country: { required },
        subject: { required, min: minLength(5), max: maxLength(250) },
        message: { required, min: minLength(6), max: maxLength(700) },
      },
    };
  },
  methods: {
    setSelectedCountryId(e) {
      this.form.country = e.target.value;
      this.validateCountry();
    },
    validateNamesurname() {
      this.userNameOut = true;
      this.v$.form.nameSurname.$validate();
    },
    validateCountry() {
      return !(this.form.country == "");
    },
    validateEmail() {
      this.emailOut = true;
      this.v$.form.email.$validate();
    },
    validateSubject() {
      this.subjectOut = true;
      this.v$.form.subject.$validate();
    },
    validateMessage() {
      this.messageOut = true;
      this.v$.form.message.$validate();
    },
    submitForm() {
      this.messageSent = false;
      this.errorSending = false;

      this.submitted = true;
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        this.sendMessage();
      }
    },
    async sendMessage() {
      if (this.sendingMessage) {
        return 0;
      }

      this.sendingMessage = true;

      this.messageSent = false;
      this.errorSending = false;

      var result = [];

      var selectedCommPlatforms = "";

      this.form.nameSurname = helper.clearHtml(this.form.nameSurname);
      this.form.subject = helper.clearHtml(this.form.subject);
      this.form.message = helper.clearHtml(this.form.message);
      this.form.companyName = helper.clearHtml(this.form.companyName);

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/home/sendMessageToDomainCompanies/?name=${this.form.nameSurname}&subject=${this.form.subject}&message=${this.form.message}&countryCode=${this.form.country}&email=${this.form.email}&companyName=${this.form.companyName}&fax=&phone=&webSite=&address=&communicationPlatformIds=${selectedCommPlatforms}&targetCompanyIds=${this.$store.state.singleCompanyIdX}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            companyId: 0,
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.sendingMessage = false;
      if (result.resultText == "Success") {
        this.messageSent = true;
        this.clearSendingMessageForm();
      } else {
        this.errorSending = true;
      }
    },
    clearSendingMessageForm() {
      if (!this.$store.state.userLoggedInX) {
        this.form.nameSurname = "";
        this.form.companyName = "";
        this.form.email = "";
        this.form.country = "";
      }

      this.userNameOut = false;
      this.emailOut = false;
      this.form.country = "";
      this.subjectOut = false;
      this.messageOut = false;

      this.form.subject = "";
      this.form.message = "";
      this.submitted = false;

      this.v$.$reset();
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.$store.state.fullCountriesX = tempList;
      this.buildCountriesInfo(this.$store.state.fullCountriesX);
    },
    buildCountriesInfo(vatiable) {
      vatiable.forEach((element) => {
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        this.countries.push({
          text: name,
          code: element.CountryCode,
          id: parseInt(element._id),
          flag: element.Flag,
        });
      });

      this.countries.unshift({
        text: this.$store.getters.getWordLocale("txt_ulke_sec"),
        code: "",
        id: 0,
        flag: "",
      });

      if (this.$store.state.userLoggedInX) {
        this.form.nameSurname = this.$store.state.userNameX;
        this.form.email = this.$store.state.userEmailX;

        if (
          this.$store.state.userCountryCodeX != "" &&
          this.$store.state.userCountryCodeX != undefined &&
          this.$store.state.userCountryCodeX != null
        ) {
          this.form.country = this.$store.state.userCountryCodeX.toUpperCase();
          this.validCountryCode = true;
        }
      }
    },
    async getCompanyInformation() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: this.$store.state.singleCompanyIdX,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullInfoX = result;

      this.buildCompanyInfo(result);
    },
    buildCompanyInfo(variable) {
      this.membershipName =
        variable.CompanyActiveMembership.Localizations.length == 0
          ? ""
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
          ? variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.memebrshipIcon = variable.CompanyActiveMembership.Icon;

      variable.CompanyContactInformations.forEach((element) => {
        var address = element.Address;
        if (this.companyAddress == "") {
          this.companyAddress = address;
        }
        if (this.contactPerson == "") {
          this.contactPerson = element.ContactPearson;
        }

        element.Phones.forEach((tel) => {
          if (this.phone == "") {
            this.phone = tel;
          }
        });
      });
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
  },
  mounted() {
    this.messageSent = false;
    this.errorSending = false;

    this.clearSendingMessageForm();

    this.companyName =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.countryName =
      this.$store.state.singleCompanyDetailsX.Country.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    if (this.$store.state.fullCountriesX.length == 0) {
      this.getCountries();
    } else {
      this.buildCountriesInfo(this.$store.state.fullCountriesX);
    }

    if (this.$store.state.singleCompanyFullInfoX.length == 0) {
      this.getCompanyInformation();
    } else {
      this.buildCompanyInfo(this.$store.state.singleCompanyFullInfoX);
    }

    var companyFirst3Words = this.companyName.split(" ").slice(0, 3).join(" ");
    this.$store.state.detailsTitleX = this.$store.getters
      .getWordLocale("txt_iletisim_seo_title")
      .replace(`{1}`, companyFirst3Words)
      .replace(`{2}`, this.countryName)
      .substr(0, 70);

    this.$store.state.detailsDescriptionX = this.$store.getters
      .getWordLocale("txt_iletisim_seo_desc")
      .replace(`{1}`, this.companyName)
      .replace(`{2}`, this.countryName);
  },
};
</script>
<style scoped>
.detail-content-box {
  margin-top: 0px;
  margin-top: 24px;
}

hr {
  margin: 50px 0;
  color: inherit;
  background-color: var(--m3--sys--light--outline);
  border: 0;
  opacity: 1;
}

.form-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.contact-page-information-form input {
  height: 56px;
  border-radius: 9px;
  background: rgba(227, 226, 230, 0.08);
}
.contact-page-information-form select {
  height: 56px;
  border-radius: 9px;
  background: rgba(227, 226, 230, 0.08);
}
.float-end {
  color: var(--m3--sys--light--primary) !important;
  margin-top: 10px;
}

.contact-page-left > section > strong {
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  color: var(--m3--sys--light--primary);
}
.contact-page-left > section > span {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
}
.red-border {
  border-color: #e1000f !important;
}

.green-border {
  border-color: #99c99b !important;
}
</style>
